const FRM_ADMIN_ROLES = new Set([
  'ADMIN',
  'ADMINISTRATOR',
  'SUPERADMIN',
  'АДМИНИСТРАТОР',
  'СУПЕРАДМИН',
]);

function normalizeFrmRole(role: string): string {
  return role.trim().toLocaleUpperCase('ru-RU').replace(/[\s_-]+/g, '');
}

export function canManageTelegramEnrollment(roles: readonly string[] | undefined): boolean {
  return roles?.some((role) => FRM_ADMIN_ROLES.has(normalizeFrmRole(role))) === true;
}
